import React from "react";
import classNames from "classnames";
const Spinner = ({ color, size, whiteBackground, inline }) => {
    const className = classNames("gui-spinner", `gui-spinner--${color}`, `gui-spinner--${size}`, {
        "gui-spinner--whiteBackground": whiteBackground
    }, { "gui-spinner--inline": inline });
    return React.createElement("span", { className: className });
};
Spinner.defaultProps = {
    color: "white",
    size: "small",
    whiteBackground: false,
    inline: false
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map